export const DEFAULT_STRING = '';
export const DEFAULT_NUMBER = 0;
export const DEFAULT_ID = -1;
export const DEFAULT_ARRAY = [];
export const DEFAULT_PAGINATION = {
	page: 1,
	per_page: 10,
	total_pages: 1,
	count: 0,
};
